import styles from '@/pages/app/BillingOps/styles.module.scss'

import { InvoiceSummary } from '@/api/generated'
import { formatMinorUnitsAsCurrency } from '@/utils/currency'

const formatAmount = formatMinorUnitsAsCurrency

const formatDate = (iso: string | null): string => {
  if (!iso) return '—'
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString()
}

const isPastDue = (invoice: InvoiceSummary): boolean => {
  if (invoice.status !== 'open' || !invoice.due_date) return false
  const due = new Date(invoice.due_date)
  return !Number.isNaN(due.getTime()) && due.getTime() < Date.now()
}

interface InvoicePickerProps {
  draft: InvoiceSummary | null | undefined
  open: InvoiceSummary | null | undefined
  selectedId: string | null
  onSelect: (invoice: InvoiceSummary) => void
}

const InvoiceCard = ({
  invoice,
  isActive,
  onClick,
}: {
  invoice: InvoiceSummary
  isActive: boolean
  onClick: () => void
}) => {
  const className = [styles.opItem, isActive ? styles.opItemActive : ''].filter(Boolean).join(' ')
  const statusLabel = isPastDue(invoice) ? 'past due' : invoice.status
  const ref = invoice.number ?? invoice.id
  return (
    <button type="button" className={className} onClick={onClick}>
      <span className={styles.opItemKind}>
        {ref} · {formatAmount(invoice.amount_due, invoice.currency)}
      </span>
      <span className={styles.opItemDescription}>
        {statusLabel} · created {formatDate(invoice.created)}
        {invoice.due_date ? ` · due ${formatDate(invoice.due_date)}` : ''}
      </span>
    </button>
  )
}

const InvoicePicker = ({ draft, open, selectedId, onSelect }: InvoicePickerProps) => {
  if (!draft && !open) return null
  return (
    <div className={styles.opList}>
      {draft && <InvoiceCard invoice={draft} isActive={draft.id === selectedId} onClick={() => onSelect(draft)} />}
      {open && <InvoiceCard invoice={open} isActive={open.id === selectedId} onClick={() => onSelect(open)} />}
    </div>
  )
}

export default InvoicePicker
